export const startGameKeyCodes = [' ', 'Enter'];
export const keyEventCodes = {keyUp: 'keyup', keyDown: 'keydown'};
export const arrowLeftKeyCode = 'ArrowLeft';
export const arrowRightKeyCode = 'ArrowRight';
export const supportedKeys = [arrowLeftKeyCode, arrowRightKeyCode];

export const inProductionMode = true;
export const autoPlayMusic = inProductionMode;

export const playerMovementPulseStrength = 0.8;
export const maximumPlayerSpeed = 10;
export const playerMovementFriction = 0.3;

export const initialSpawnRate = 0;
export const maximumCollectibleSpawnRate = 20;
export const collectibleDropMovementIncrement = 3;
export const updateSpeedMillis = 20;
export const collectibleSpawnIncreasingRate = 0.05;
export const collectibleSpawnChanceLowerLimit = 0.98;

export const playerImageHeight = 90;
export const playerImageWidth = 100;
export const collectibleDeadImageDifference = 21;
export const collectibleDeadImageDifferenceX = 3;
export const collectibleImageHeight = 40;
export const collectibleImageWidth = 40;
export const deadCollectibleRenderLimit = 200;

export const disableSpawning = false;
